import { throttle } from 'lodash';

export function scrollAction() {
  window.addEventListener(
    'scroll',
    _.throttle(
      e => {
        // ここに処理

        //追従バナー
        const anchor = document.querySelector('.js-anchor');
        const scrollTarget = document.querySelector('.js-scrollTarget');
        const footerPos = document.querySelector('.js-footerPos');

        if( scrollTarget.classList.contains('is-animated') == true ){
          //何か処理を書く
          anchor.classList.add('is-active');
        } else {
          anchor.classList.remove('is-active');
        }

        const windowBottom = window.scrollY + window.innerHeight;
        const footerTop = footerPos.getBoundingClientRect().top + window.scrollY;
        if (windowBottom >= footerTop) {
          anchor.classList.add('is-hidden');
        } else {
          anchor.classList.remove('is-hidden');
        }
        return false;
      },
      50,
      { trailing: true, leading: true }
    )
  );
}